var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 111.13 40.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#39cefd;}.cls-4{fill:#03569b;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#16b9fd;}.cls-7{fill:url(#radial-gradient);}.cls-8{fill:gray;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.56,18.61,21.71,29.46,32.56,40.32H20.16L15.5,35.67l-6.2-6.2L20.16,18.61ZM20.16,0,0,20.16l6.2,6.2L32.56,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8171.65,
    y1: 3393.54,
    x2: -8165.14,
    y2: 3400.05,
    gradientTransform: "matrix(0, 0, 0, 0, -1325.17, -664.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 16.28,
    cy: 20.16,
    r: 18.32,
    gradientTransform: "matrix(0, 0, 0, 0, -1325.17, -664.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flutter-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.5,35.67,32.56,18.61H20.16L9.3,29.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,20.16,20.16,0h12.4L6.2,26.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.16,40.32h12.4L21.71,29.46l-6.2,6.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.71,29.46l-6.2,6.2,9.2-3.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M9.3,29.46l6.2-6.2,6.2,6.2-6.2,6.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.56,18.61,21.71,29.46,32.56,40.32H20.16L15.5,35.67l-6.2-6.2L20.16,18.61ZM20.16,0,0,20.16l6.2,6.2L32.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.49,10.81H47.36v2.07H38.77V19.3h7.76v2.07H38.77v8.08H36.59V10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.95,10.81h2.17V29.55H49.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M60.3,30a4.91,4.91,0,0,1-3.73-1.45,5.78,5.78,0,0,1-1.24-3.93V16.19H57.5v8.08a4.28,4.28,0,0,0,.83,2.8,3.12,3.12,0,0,0,2.38.93,3.19,3.19,0,0,0,2-.62A3.87,3.87,0,0,0,64,25.82a4.71,4.71,0,0,0,.52-2.07V16.19h2.17V29.55H64.65v-2h-.1a4.55,4.55,0,0,1-1.76,1.66A4.13,4.13,0,0,1,60.3,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75.41,29.75a4.15,4.15,0,0,1-1.55-.31,4.27,4.27,0,0,1-1.14-.72,4.6,4.6,0,0,1-.83-1.14A3.46,3.46,0,0,1,71.58,26V18.16H69.2v-2h2.38V12.46h2.17v3.73H77v2H73.76V25.4a2.63,2.63,0,0,0,.41,1.66,1.74,1.74,0,0,0,1.45.62,2.38,2.38,0,0,0,1.45-.41v2.17c-.31.1-.52.21-.83.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M84.84,29.75a4.15,4.15,0,0,1-1.55-.31,4.27,4.27,0,0,1-1.14-.72,4.6,4.6,0,0,1-.83-1.14A3.46,3.46,0,0,1,81,26V18.16H78.83v-2h2.38V12.46h2.17v3.73H86.6v2H83.39V25.4a2.63,2.63,0,0,0,.41,1.66,1.74,1.74,0,0,0,1.45.62,2.38,2.38,0,0,0,1.45-.41v2.17c-.31.1-.52.21-.83.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.67,30A6.52,6.52,0,0,1,91.25,29a6.85,6.85,0,0,1-2.38-2.48A8.12,8.12,0,0,1,88,22.92a8,8,0,0,1,.83-3.52,6.89,6.89,0,0,1,2.28-2.59,6.31,6.31,0,0,1,9,2.38,7.68,7.68,0,0,1,.83,3.52,1.54,1.54,0,0,1-.1.72H90.22A6.34,6.34,0,0,0,90.94,26a4,4,0,0,0,1.66,1.55,5.09,5.09,0,0,0,2.07.52,4.34,4.34,0,0,0,3.93-2.38l1.86.93a7.16,7.16,0,0,1-2.38,2.59,7.62,7.62,0,0,1-3.42.72Zm3.83-8.49A3.44,3.44,0,0,0,98,19.81a4.42,4.42,0,0,0-1.35-1.45,3.94,3.94,0,0,0-2.28-.62,3.67,3.67,0,0,0-2.69,1,5.2,5.2,0,0,0-1.45,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.47,16.19h2.07v2.17h.1a3.2,3.2,0,0,1,1.55-1.76,4,4,0,0,1,2.38-.72,3.46,3.46,0,0,1,1.55.31v2.38a3.55,3.55,0,0,0-1.86-.41,3.49,3.49,0,0,0-1.76.52,6.05,6.05,0,0,0-1.35,1.45,4.28,4.28,0,0,0-.52,2v7.45h-2.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterLogo);
export default __webpack_public_path__ + "static/media/flutter-logo.d986abf1103895e848268553189f7f59.svg";
export { ForwardRef as ReactComponent };